export enum StarRatingEvents {
  CHANGE = 'starRatingChanged',
}
